import React from 'react'

export function EmailSvg() {
  return (
    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 2.46V2H18V2.46L10 7.8L2 2.46ZM0 3.03V14C0 14.5304 0.210714 15.0391 0.585786 15.4142C0.960859 15.7893 1.46957 16 2 16H18C18.5304 16 19.0391 15.7893 19.4142 15.4142C19.7893 15.0391 20 14.5304 20 14V2C20 1.46957 19.7893 0.960859 19.4142 0.585786C19.0391 0.210714 18.5304 0 18 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V3.02V3.03ZM2 4.87L9.45 9.83C9.61328 9.93753 9.8045 9.99483 10 9.99483C10.1955 9.99483 10.3867 9.93753 10.55 9.83L18 4.87V14H2V4.87Z"
        fill="currentColor"
      />
    </svg>
  )
}
